import React from 'react';

import { useThemeDefinition } from '@tanium/react-theme-definition';

import { AxisStroke } from '../Axis/themeDefinitions';
import { Svg } from '../Svg';

export const OverlayVerticalAxisLine = ({
  yMin,
  yMax,
  height,
  plotLeft,
}: {
  yMin: number;
  yMax: number;
  height: number;
  plotLeft: number;
}): JSX.Element => {
  const axisStrokeColor = useThemeDefinition(AxisStroke);
  return (
    <Svg width={2} height={height} style={{ position: 'absolute', left: plotLeft }}>
      <line x1={0} x2={0} y1={yMin} y2={yMax} stroke={axisStrokeColor} />
    </Svg>
  );
};
